import { useState, forwardRef, useImperativeHandle } from 'react'
import Cell from '@/components/Cell'
import Icon from '@/components/Icon/Icon'
import DeliveryAddress from '@/components/DeliveryAddress'
import { storageUtil } from '@/utils'
import { useCorpInfoStore } from '@/stores'
import styles from './index.module.less'
import { CustomerAddress } from '@/pages/Order/types'

const { getLocalStorage } = storageUtil

interface IProps {
  canEdit?: boolean
  pfUserId: string,
  backgroundColor?: string
  onSave?(customer: CustomerAddress): void
  [key: string]: any
}

const OrderAddress = forwardRef((props: IProps, ref) => {
  const { canEdit = true, pfUserId, backgroundColor = '#fff', onSave } = props
  const { corpInfo } = useCorpInfoStore()
  const { pfUser } = corpInfo || {}
  const [deliveryVisible, setDeliveryVisible] = useState(false)
  const [customer, setCustomer] = useState<CustomerAddress>({
    totalAddress: '',
    name: '',
    phone: '',
    area: [],
    address: '',
  })
  const zoneNumber = getLocalStorage('zoneNumber')

  useImperativeHandle(ref, () => ({
    onOpenAddress
  }))

  // 地址点击
  function onOpenAddress() {
    if (!canEdit) return
    setDeliveryVisible(true)
  }

  function onAddressChange(customerData: CustomerAddress) {
    setCustomer(customerData)
  }

  // 地址选择完毕
  function onAddressSave(customerData: CustomerAddress) {
    setCustomer(customerData)
    setDeliveryVisible(false)
    onSave?.(customerData)
  }

  const customerPhone = <>
    { zoneNumber && <span className={ styles["zone-number"]}>{ zoneNumber }</span> }
    <span>{ customer.phone }</span>
  </>

  return (
    <div onClick={ onOpenAddress } style={ { backgroundColor: backgroundColor } }>
      <Cell arrowSize={ 18 } padding="8px 16px"
        right={ canEdit ? undefined : null }>
        <div className={ styles["address-section"]}>
          <Icon name="location" color="#FE5700"></Icon>
          <div className={ styles["address-box"]}>
            <div className={ `${styles["address-title"]} ep-2`}>{ customer.totalAddress }</div>
            <div className={ `${styles["address-content"]} ep`}>{ customer.name } { customerPhone }</div>
          </div>
        </div>
      </Cell>

      <DeliveryAddress
        visible={ deliveryVisible }
        pfUserId={ pfUserId }
        initData={ pfUser }
        onCancel={ () => setDeliveryVisible(false) }
        onOk={ onAddressSave }
        onChange={ onAddressChange }
      />
    </div>
  )
})

export default OrderAddress
